module.exports = __webpack_public_path__ + "static/processimg-9eb6a7a6e8a99757cec47296806bba42.png";